import React from 'react';
import styles from '../search.scss';

const PaidHitClubsHeaderColumns = props => {
    const {
        filterType,
        paidHitClubs,
        // functions
        sortResults,
    } = props;

    let sortValue = '';
    if (paidHitClubs.sort && paidHitClubs.sort.field) {
        sortValue = `${paidHitClubs.sort.field}_${paidHitClubs.sort.asc ? 'asc' : 'desc'}`;
    }
    const sortOptions = [
        { value: 'name_asc', label: 'Name: A to Z' },
        { value: 'name_desc', label: 'Name: Z to A' },
    ];

    const sort = (val) => {
        const sortBy = val.split('_');
        sortResults('paidHitClubs', sortBy[0], sortBy[1]);
    };

    const getFilterColumnHeaderText = (columnFiled, columnHeader, nonFilterTypeText) => {
        if (!filterType && nonFilterTypeText) {
            return (<span data-testid="search.paid-hit-clubs.column-header.name-label">{nonFilterTypeText}</span>);
        }

        return (
            <span data-testid="search.paid-hit-clubs.column-header.name-label">
                {columnHeader}
                &nbsp;
                <i className={`uts ${paidHitClubs.sort.field === columnFiled && !paidHitClubs.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />
            </span>
        );
    };

    if (paidHitClubs.total <= 0) {
        return <></>;
    }

    return (
        <div>
            <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.paid-hit-clubs.column-headers">
                <div className="flex-grow">
                    <div className="row">
                        <div
                            className={`col-md-6 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && paidHitClubs.sort.field === 'name' ? 'active' : ''}`}
                            onClick={() => { return filterType ? sortResults('paidHitClubs', 'name') : null; }}
                            data-testid="search.paid-hit-clubs.column-header.name"
                        >
                            {getFilterColumnHeaderText('name', 'Name', 'Paid Hit Clubs')}
                        </div>
                        <div className={`col-md-3 ${styles.searchHeaderColumn}`} data-testid="search.paid-hit-clubs.column-header.availability">Paid Hit Availability</div>
                        <div className={`col-md-3 ${styles.searchHeaderColumn}`} data-testid="search.paid-hit-clubs.column-header.location">Location</div>
                    </div>
                </div>
            </div>
            <div className={`${styles.searchHeaders} d-block d-md-none`} data-testid="search.paid-hit-clubs.column-headers-mobile">
                {filterType ? (
                    <div data-testid="search.paid-hit-clubs.sort-by-wrapper">
                        Sort by
                        <select
                            className="inline-input"
                            value={sortValue}
                            onChange={(e) => sort(e.target.value)}
                            data-testid="search.paid-hit-clubs.sort-select"
                        >
                            <option value="">Relevance</option>
                            {sortOptions.map((option, i) => <option value={option.value} key={`paidHitClubSort${i}`}>{option.label}</option>)}
                        </select>
                    </div>
                ) : 'Paid Hit Clubs'}
            </div>
        </div>
    );
};

export default PaidHitClubsHeaderColumns;
